import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { SharedModule } from '@/shared.module';
import type { SaveState } from '../../types/careplan-nnn.types';

/**
 * One editable notes cell of the careplan-NNN row table: an autosizing
 * textarea with a character counter and an autosave hint. Emits every
 * keystroke via `valueInput` (the parent mutates the row) and `save` on
 * focusout (the parent persists the row).
 */
@Component({
  selector: 'app-nnn-notes-cell',
  standalone: true,
  imports: [SharedModule],
  templateUrl: './nnn-notes-cell.component.html',
  styleUrl: './nnn-notes-cell.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NnnNotesCellComponent {
  readonly labelKey = input.required<string>();
  readonly value = input<string | null>(null);
  readonly disabled = input(false);
  readonly saveState = input<SaveState>('');
  readonly showCounter = input(false);

  readonly valueInput = output<string>();
  readonly save = output<void>();
}
